import styled from 'styled-components';

export const ResultContainer = styled.div`
  display: flex;
  flex-direction: column;

  margin-top: 0.5rem;
  background-color: ${({ theme }) => theme.colors.white};
  font-family: ${({ theme }) => theme.fonts.workSans};

  padding: 1.5rem;

  gap: 1rem;
`;

export const ResultTitle = styled.span`
  font-weight: 600;
  font-size: 24px;
  line-height: 32px;
  color: ${({ theme }) => theme.colors.grayDark3};
  font-family: 'Source Sans Pro';
`;

export const ResultSubtitle = styled.span`
  font-weight: 400;
  font-size: 1rem;
  line-height: 24px;
  color: ${({ theme }) => theme.colors.grayDark4};
  font-family: ${({ theme }) => theme.fonts.workSans};

  span::after {
    content: '"';
  }
  span::before {
    content: '"';
  }
`;

export const ResultHeader = styled.div`
  display: flex;
  flex-direction: column;

  gap: 0.5rem;
`;

export const AccordionContainer = styled.div`
  display: grid;
  gap: 1rem;

  .hefesto-accordion__item .hefesto-accordion__item__header {
    display: flex;
    gap: 1rem;

    .hefesto-accordion__title h4 {
      font-weight: 600;
      font-size: 1rem;
      line-height: 24px;
      color: #555555;
      font-family: ${({ theme }) => theme.fonts.workSans};
      margin-bottom: 0;
    }
  }
`;

export const ResultAccordionTitle = styled.span`
  font-family: ${({ theme }) => theme.fonts.workSans};
  font-weight: 400;
  font-size: 14px;
  line-height: 22px;
  color: ${({ theme }) => theme.colors.grayDark3};
`;

export const Message = styled.h4`
  color: ${({ theme }) => theme.colors.grayDark4};
  font-size: 20px;
  line-height: 28px;
  font-family: 'Source Sans Pro';
  font-weight: 400;
  text-align: center;
  width: 31rem;
`;

export const ContainerMessage = styled.div`
  position: relative;

  background-color: #efefef;
  height: 33rem;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  > div {
    position: absolute;
    top: 1.5rem;
    left: 1.5rem;
  }
`;
